import React from 'react';
import PropTypes from 'prop-types';
import { NAVIGATION_CONFIG } from './navigation.config';
import { ANavigationLink, ANavigationLinkMultiList } from '../../atoms';

export default function MNavigationFooter({ theme }) {
	const linkConfig = theme === undefined ? [] : NAVIGATION_CONFIG[theme];
	const links = linkConfig.map((link) => {
		switch (link.type) {
			case 'dropDown':
				return <ANavigationLinkMultiList {...link} />;
			default:
				return <ANavigationLink {...link} />;
		}
	});

	return (
		<nav className="m-footer-navigation">
			<ul className="link-list">
				{links}
			</ul>
		</nav>
	);
}

MNavigationFooter.propTypes = {
	theme: PropTypes.string,
};

MNavigationFooter.defaultProps = {
	theme: undefined,
};



// WEBPACK FOOTER //
// ./src/components/molecules/navigation/_molecule.navigation-footer.js